module.exports = __webpack_public_path__ + "static/media/menu-profil.6f35028b.svg";